import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Company, RealProperty } from '@eemo/api-client';
import { PropertyReferentAssociationComponent } from '../property-referent-association/property-referent-association.component';
import { NgTemplateOutlet } from '@angular/common';
import { ModalBaseComponent } from '../base/modal-base/modal-base.component';


export class PropertySettingsDialogData {
  property: RealProperty;
}

@Component({
    selector: 'app-property-settings-dialog',
    templateUrl: './property-settings-dialog.component.html',
    styleUrls: ['./property-settings-dialog.component.scss'],
    standalone: true,
    imports: [ModalBaseComponent, NgTemplateOutlet, MatDialogModule, PropertyReferentAssociationComponent]
})
export class PropertySettingsDialogComponent implements OnInit {

  dialogTitle = 'propertySettingsDialog.title';
  dialogTitleParams = {
    company: ''
  };
  property: RealProperty;

  constructor(@Inject(MAT_DIALOG_DATA) public data: PropertySettingsDialogData,
  public dialogRef: MatDialogRef<PropertySettingsDialogComponent>) {
    this.property = data.property;
  }

  ngOnInit(): void {
  }
}
